<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="item" style="position: relative">
        <v-container class="grey lighten-5">
          <v-form
            ref="form"
            autocomplete="off"
            method="post"
            action=""
          >
            <v-row no-gutters class="pagination-table-header">
              <v-col
                v-if="regionsItems"
                cols="12"
                md="4">
                <v-select
                  v-model="item.region"
                  :hint="$t('hints.region')"
                  :items="regionsItems"
                  persistent-hint
                  single-line
                  @change="updateRequest('region', $event)"
                  :loading="false"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.name"
                  :counter="50"
                  :rules="[rules.required, rules.max(50)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.title')"
                  autocomplete="off"
                  :error-messages="(errors && errors.name)?errors.name:null"
                  @input="removeError('name')"
                  @change="updateRequest('name', $event)"
                  :loading="isRequestingNow.includes('name')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.note"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.note')"
                  autocomplete="off"
                  :error-messages="(errors && errors.note)?errors.note:null"
                  @input="removeError('note')"
                  @change="updateRequest('note', $event)"
                  :loading="isRequestingNow.includes('note')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.link"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.link')"
                  autocomplete="off"
                  :error-messages="(errors && errors.link)?errors.link:null"
                  @input="removeError('link')"
                  @change="updateRequest('link', $event)"
                  :loading="isRequestingNow.includes('link')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                class="py-md-0"
              >
                {{$t('warehouse.representative')}}:
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.contact_name"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.name')"
                  autocomplete="off"
                  :error-messages="(errors && errors.contact_name)?errors.contact_name:null"
                  @input="removeError('contact_name')"
                  @change="updateRequest('contact_name', $event)"
                  :loading="isRequestingNow.includes('contact_name')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="py-md-0"
              >
                <v-text-field
                  :disabled="pageLoading"
                  v-model="item.contact_phone"
                  v-mask="'+380 (##) ###-##-##'"
                  :rules="[rules.phone]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.phone')"
                  autocomplete="off"
                  :error-messages="(errors && errors.contact_phone)?errors.contact_phone:null"
                  @input="removeError('contact_phone')"
                  @change="updateRequest('contact_phone', $event)"
                  :loading="isRequestingNow.includes('contact_phone')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                class="py-md-0"
              >
                <v-text-field
                  type="email"
                  :disabled="pageLoading"
                  v-model="item.contact_email"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="$t('general.email')"
                  autocomplete="off"
                  :error-messages="(errors && errors.contact_email)?errors.contact_email:null"
                  @input="removeError('contact_email')"
                  @change="updateRequest('contact_email', $event)"
                  :loading="isRequestingNow.includes('contact_email')"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="isCreation"
                cols="12"
                class="text-right pt-3"
              >
                <v-btn
                  @click.prevent="createItem"
                  type="submit" color="primary" :loading="pageLoading"
                > {{ $t('general.create') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import validationMixin from '@/mixins/validationMixin';
import regionsFilter from '@/mixins/filters/regionsFilter';
import { prepareValidationMessages } from '@/utils';
import paginationMixin from '@/mixins/listing/paginationMixin';
import { DATETIME_VIEW } from '@/constants/dates';
import StockVendorProxy from '@/proxies/Stock/StockVendorProxy';
import { mask } from 'vue-the-mask';

export default {
  name: 'StockVendorShow',
  directives: { mask },
  mixins: [
    updatePageContentMixin,
    validationMixin,
    regionsFilter,
    paginationMixin,
  ],
  components: {},
  data() {
    return {
      moment,
      DATETIME_VIEW,
      isCreation: true,
      pageLoading: false,
      shouldSeeLoaderOnUpdating: true,
      useNullableRegion: false,
      isRequestingNow: [],
      item: {
        region: 'kyiv',
      },
      errors: {},
      updatingData: {},
      currentEditableItem: {},
    };
  },
  created() {
    this.pageLoading = true;
    this.fetchData();
  },
  watch: {
    '$route.params.item': {
      handler() {
        this.fetchData();
      },
    },
  },
  methods: {
    fetchData() {
      if (this.$route.params.item === 'new') {
        this.isCreation = true;
        this.pageLoading = false;
        this.$store.dispatch('page/finishUpdateCurrentPageContent');
      } else {
        this.isCreation = false;
        new StockVendorProxy().find(this.$route.params.item)
          .then((response) => {
            this.item = response.data.data.item;
            return Promise.resolve(this.item);
          })
          .catch((error) => {
            console.error(error);
            /* return this.$router.push({
                              name: 404,
                            }); */
          })
          .finally(() => {
            this.pageLoading = false;
            this.$store.dispatch('page/finishUpdateCurrentPageContent');
          });
      }
    },
    updateRequest(property, val) {
      if (!this.pageLoading && !this.isCreation) {
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.item, property))(val)
          .catch((response) => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    updateSimpleRequest(item, property) {
      return (value) => {
        const data = {};
        data[property] = value;
        this.updatingData[item.id] = true;
        this.$forceUpdate();
        return new StockVendorProxy().update(item.id, data)
          .then((response) => {
            item[property] = response.data.data.item[property];
          })
          .finally(() => {
            delete this.updatingData[item.id];
            this.$forceUpdate();
          });
      };
    },
    createItem() {
      if (this.$refs.form.validate()) {
        this.pageLoading = true;
        new StockVendorProxy().create({
          name: this.item.name,
          note: this.item.note,
          measure: this.item.measure,
        })
          .then((response) => {
            if (response.data.data.item.id) {
              this.item = {};
              this.$router.push({
                name: 'stock-vendors.show',
                params: { item: response.data.data.item.id },
              });
            } else {
              console.error(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.errors = prepareValidationMessages(error.data.data);
          })
          .finally(() => {
            this.pageLoading = false;
            this.$store.dispatch('page/finishUpdateCurrentPageContent');
          });
      }
    },
    onCloseDialog(item) {
      this.isShowIncomeDialog = false;
      this.isShowExpenseDialog = false;
    },
    onActionDialog(item) {
      this.fetchData();
      this.onCloseDialog();
    },
  },
};
</script>
